import styled from '@emotion/styled'
import { Text } from 'components/common/styles'
import { keyframes } from '@emotion/core'

export const Details = styled.div`
  display: grid;
  grid-template-columns: 1fr 487px 1fr;
  grid-template-rows: 67px repeat(2, 1fr) 67px;
  grid-column-gap: 65px;
  margin: 1em 0 90px 0;
  
  font-size: 100px;
  
  @media screen and (max-width: 1280px) {
    margin: .3em 0 .3em 0;
    grid-template-columns: 1fr 300px 1fr;
  }

  @media screen and (max-width: 1024px) {
      display: flex;
      flex-direction: column;
      margin: 60px 0 90px 0;
  }
  
  @media screen and (max-width: 768px) {
      margin: 1em 0 90px 0;
  }
`

export const SectionTitle = styled.h3`
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
`

export const ItemContainer = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 64px;
  }
  
  @media screen and (max-width: 1024px) {
      order: 2;
  }
`

const rotation = keyframes`
   from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const GraphContainer = styled.div`
  position: relative;
  width: 100%;
  
  @media screen and (max-width: 768px) {
     max-width: 100vw;
  }
  
  @media screen and (max-width: 1024px) {
    width: 60%;
  }
  
  @media screen and (max-width: 768px) {
    width: 80%;
    margin-bottom: 20px;
  }
`

export const FinalPosition = styled.div`
  position: relative;
  grid-area: 1 / 2 / 5 / 3;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 100%;
    
    .outer {
      animation: ${rotation} linear 60s infinite;
      transform-origin: center center;
    }
  }
  
  @media screen and (max-width: 1024px) {
  }
`

export const InfoText = styled(Text)`
  margin-top: 16px;
`

type CardVideoContainerProps = {
  visible: boolean
}
export const CardVideoContainer = styled.div<CardVideoContainerProps>`
  position: absolute;
  width: 246%;
  left: 50%;
  transform: translateX(-50%) translateY(-42%);
  overflow: visible;
  
  display: ${props => props.visible ? 'block' : 'none'};
  
  canvas {
    width: 100%;
  }
  
  @media screen and (max-width: 1024px) {
    display: none;
  }
`

export const CardVideo = styled.video`
  width: 100%;
`

export const CardImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0 5px 30px rgba(8, 34, 32, 0.2);
  border-radius: 16px;
`
